// DS: IL3.5
import React from 'react';

export const Lock: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="90"
      height="88"
    >
      <defs>
        <linearGradient
          id="lock-il-a"
          x1="7.226%"
          x2="31.886%"
          y1="4.624%"
          y2="50%"
        >
          <stop offset="0%" stopColor="#FFF"></stop>
          <stop offset="20%" stopColor="#CCFAEB"></stop>
          <stop offset="40%" stopColor="#99F5D7"></stop>
          <stop offset="60%" stopColor="#66EFC3"></stop>
          <stop offset="80%" stopColor="#33EAAF"></stop>
          <stop offset="100%" stopColor="#00E59B"></stop>
        </linearGradient>
        <linearGradient
          id="lock-il-b"
          x1="15.983%"
          x2="50%"
          y1="79.503%"
          y2="37.093%"
        >
          <stop offset="0%" stopColor="#FFF" stopOpacity="0"></stop>
          <stop offset="100%" stopColor="#FFF"></stop>
        </linearGradient>
        <linearGradient
          id="lock-il-c"
          x1="8.616%"
          x2="67.615%"
          y1="11.011%"
          y2="61.36%"
        >
          <stop offset="0%" stopColor="#F3F3F3"></stop>
          <stop offset="40%" stopColor="#E7E7E7"></stop>
          <stop offset="60%" stopColor="#DADADA"></stop>
          <stop offset="80%" stopColor="#CECECE"></stop>
          <stop offset="100%" stopColor="#C2C2C2"></stop>
        </linearGradient>
        <linearGradient
          id="lock-il-d"
          x1="9.367%"
          x2="50%"
          y1="-32.681%"
          y2="67.278%"
        >
          <stop offset="0%" stopColor="#161A1F" stopOpacity="0"></stop>
          <stop offset="100%" stopColor="#161A1F"></stop>
        </linearGradient>
        <path
          id="lock-il-e"
          d="M36.68 63.736l3.77-7.883-1.108-1.36-.583-4.223 2.65-3.683L45.693 46l3.416 2.71.571 4.375-2.616 3.496-1.588.621L44.894 66z"
        ></path>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="url(#lock-il-a)"
          fillRule="nonzero"
          d="M66.463 16.118l-6.032-5.939L52.17 8l-8.249 2.155-6.056 5.94-2.014 7.368-3.171 12.875 5.46 1.44 3.421-13.799 1.371-5.002 3.91-3.831 5.328-1.406 1.74.469 3.589.949 3.898 3.83 1.406 5.237-7.188 26.334 1.752.457 3.732.984 7.581-27.764z"
        ></path>
        <path
          fill="url(#lock-il-b)"
          fillRule="nonzero"
          d="M38.68 17.599l1.931.401 4.058-4.584 5.517-1.349L50.68 10l-6.54 1.714z"
        ></path>
        <path
          fill="url(#lock-il-c)"
          fillRule="nonzero"
          d="M26.452 30l35.334 9.609.023.049 7.392 1.994 4.479 9.271-6.568 24.659L59.013 81l-7.319-2.02-.05.035-35.972-9.761-3.992-8.628 6.649-25.232z"
        ></path>
        <use fill="url(#lock-il-d)" xlinkHref="#lock-il-e"></use>
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M47.326 43l3.868 5.267 6.486-.621-5.26 3.853.614 6.501-3.853-5.26-6.501.614 5.267-3.868z"
        ></path>
      </g>
    </svg>
  );
};
Lock.displayName = 'Lock';
